export const STORAGE_TOKEN = "onecity-token";
export const EMPTY_VALUE = "—";
